export default __webpack_public_path__ + "static/media/bubble_nova_l3.ba0b6c69.png";